import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "table table-hover align-middle" }
const _hoisted_2 = { class: "pb-2 border-dark border-bottom" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  colspan: 4,
  class: "fw-bold small text-uppercase text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasePlaceholderTable = _resolveComponent("BasePlaceholderTable")!
  const _component_PimLabProductsOverviewTableItem = _resolveComponent("PimLabProductsOverviewTableItem")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", _hoisted_2, [
      _createElementVNode("tr", null, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('cnkCode')), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('name')), 1)
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_ctx.ui.isNotReady())
        ? (_openBlock(), _createBlock(_component_BasePlaceholderTable, {
            key: 0,
            "n-cols": 4
          }))
        : (_ctx.ui.isReady() && !_ctx.hasProducts)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
              _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.$t('noResults')), 1)
            ]))
          : (_ctx.ui.isReady() && _ctx.hasProducts)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.productsOverview.results, (product) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: product.id,
                  class: "position-relative"
                }, [
                  _createVNode(_component_PimLabProductsOverviewTableItem, {
                    product: product,
                    onOpenOffCanvasProductDetail: ($event: any) => (_ctx.$emit('openOffCanvasProductDetail', product))
                  }, null, 8, ["product", "onOpenOffCanvasProductDetail"])
                ]))
              }), 128))
            : _createCommentVNode("", true)
    ])
  ]))
}